import api from "./api"

/**
 * Camada de SUPORTE do robô fundida na tela de conversas-whatsapp.
 *
 * Bate nos endpoints `meta/suporte/*` do backend (MetaAPIResource), usando o MESMO axios `api`
 * e o MESMO padrão de auth da tela (header `Authorization` = chaveSistema; `idEstabelecimento` no
 * path, vindo da loja do login — não do `estabelecimentoAtualCF`). Por isso NÃO reusa `apiRobo`,
 * que resolve o tenant por outra fonte e bate em `robosc/*`.
 *
 * Tudo é endereçado por CONTATO (telefone/wa_id), para casar com a conversa da tela.
 */

type Dict = { [k: string]: any }

const auth = (): Dict => ({
    headers: {
        Authorization: localStorage.getItem("chaveSistema"),
        "Content-Type": "application/json",
    },
})

export interface TicketSuporte {
    id: number
    contato: string
    nome?: string
    status: "PENDENTE" | "EM_ATENDIMENTO" | "FECHADO"
    categoria?: string
    atendenteUsuarioId?: number
    humanoSolicitado?: boolean
    previaPrimeiraMensagem?: string
    ultimaMensagemEm?: number | string
    abertoEm?: number | string
    iaRespostas?: number
    iaPreatende?: boolean
    iaPausada?: boolean
    iaPausadaAte?: number | string
}

export const RoboSuporteMeta = {
    listarTickets: (estab: number, params?: Dict): Promise<TicketSuporte[]> =>
        api.get(`meta/suporte/tickets/${estab}`, { params, ...auth() }).then(r => r.data || []),

    ticketPorContato: (estab: number, contato: string): Promise<TicketSuporte | null> =>
        api.get(`meta/suporte/ticket/${estab}/${encodeURIComponent(contato)}`, auth()).then(r => r.data || null),

    contexto: (estab: number, contato: string): Promise<any[]> =>
        api.get(`meta/suporte/contexto/${estab}/${encodeURIComponent(contato)}`, auth()).then(r => r.data || []),

    pegar: (estab: number, ticketId: number, categoria?: string): Promise<TicketSuporte> =>
        api.post(`meta/suporte/ticket/${estab}/${ticketId}/pegar`, { categoria }, auth()).then(r => r.data),

    transferir: (estab: number, ticketId: number, para: number, categoria?: string): Promise<TicketSuporte> =>
        api.post(`meta/suporte/ticket/${estab}/${ticketId}/transferir`, { para, categoria }, auth()).then(r => r.data),

    fechar: (estab: number, ticketId: number, opts?: { notaFechamento?: string; followup?: boolean }): Promise<TicketSuporte> =>
        api.post(`meta/suporte/ticket/${estab}/${ticketId}/fechar`, { followup: true, ...opts }, auth()).then(r => r.data),

    reabrir: (estab: number, ticketId: number): Promise<TicketSuporte> =>
        api.post(`meta/suporte/ticket/${estab}/${ticketId}/reabrir`, {}, auth()).then(r => r.data),

    pausarIa: (estab: number, contato: string, horas = 4): Promise<void> =>
        api.post(`meta/suporte/ia/${estab}/${encodeURIComponent(contato)}/pausar?horas=${horas}`, {}, auth()).then(() => undefined),

    retomarIa: (estab: number, contato: string): Promise<void> =>
        api.post(`meta/suporte/ia/${estab}/${encodeURIComponent(contato)}/retomar`, {}, auth()).then(() => undefined),
}

/** Badge de status do ticket (porte fiel de Atendimentos.tsx statusTicketBadge). */
export function statusTicketBadge(t?: TicketSuporte | null): { label: string; cor: "pendente" | "atendimento" | "fechado" | "humano" } | null {
    if (!t) return null
    if (t.humanoSolicitado) return { label: "🙋 pediu humano", cor: "humano" }
    if (t.status === "PENDENTE") return { label: "🎫 pendente", cor: "pendente" }
    if (t.status === "EM_ATENDIMENTO") return { label: "🎧 em atendimento", cor: "atendimento" }
    if (t.status === "FECHADO") return { label: "✅ fechado", cor: "fechado" }
    return null
}
